import STORAGE_KEYS from '@/configs/local-storage-keys';
import useWorkspaceStorage from '@/hooks/pure/useWorkspaceStorage';

import type { NavigatorBaseItem } from '../types/navigatorTypes';

const MAX_HISTORY_SIZE = 10;

const useNavigatorHistory = () => {
  const [history, setHistory] = useWorkspaceStorage<NavigatorBaseItem[]>(
    STORAGE_KEYS.NAVIGATOR_HISTORY,
    [],
  );

  const addHistory = (item: NavigatorBaseItem) => {
    const newHistory = [...history];
    newHistory.upsert(item, (history) => {
      return history.target === item.target && history.alias === item.alias;
    });

    if (newHistory.length > MAX_HISTORY_SIZE) {
      newHistory.shift();
    }
    setHistory(newHistory);
  };

  const clearHistory = () => {
    setHistory([]);
  };

  return {
    history,
    addHistory,
    clearHistory,
  };
};

export default useNavigatorHistory;
